import { render } from "./CallThisWeekTabCont.vue?vue&type=template&id=359aa986"
import script from "./CallThisWeekTabCont.vue?vue&type=script&lang=js"
export * from "./CallThisWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__